export const PREF_CLASS_NAME = 'termly-display-preferences'

export const DISABLED_PREF_CLASS_NAME = `${ PREF_CLASS_NAME }--disabled`
